module.exports = __webpack_public_path__ + "img/cart.809fbe98.png";